
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/presenting",
      function () {
        return require("private-next-pages/presenting/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/presenting"])
      });
    }
  